import React from 'react';
import AppCOLORS, { AppColorClass, eventBgColors, eventColors } from '../../constant/ColorConfig';
 

const CalendarEventContent = ({ eventInfo }) => {
    const {type, status} = eventInfo.event.extendedProps;
    const colorClass = AppColorClass[status] || 'bg-gray-400';

    return (
        <div className="flex items-center gap-2 p-1 w-full overflow-hidden text-xs">
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${colorClass}`}></span>
            <span className="truncate font-medium">{eventInfo.event.title} {status}</span>
        </div>
    );
};

export default CalendarEventContent;
